module.exports = __webpack_public_path__ + "media/categories/2019-6035a2d8.svg";